export enum OperationType {
  COINS_GIFT = 'COINS_GIFT',
  COINS_PURCHASE = 'COINS_PURCHASE',
  COINS_ORDER = 'COINS_ORDER',
}
